import { render, staticRenderFns } from "./PartnerAnalysesCard.vue?vue&type=template&id=629d7231&scoped=true&"
import script from "./PartnerAnalysesCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PartnerAnalysesCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PartnerAnalysesCard.vue?vue&type=style&index=0&id=629d7231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629d7231",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629d7231')) {
      api.createRecord('629d7231', component.options)
    } else {
      api.reload('629d7231', component.options)
    }
    module.hot.accept("./PartnerAnalysesCard.vue?vue&type=template&id=629d7231&scoped=true&", function () {
      api.rerender('629d7231', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/pages/AnalysesListPage/components/PartnerAnalysesCard.vue"
export default component.exports